import { t } from "i18next";
import React, { useState } from "react";
import PresortDemo from "../components/table/DataTable";
import { userColumn, userMessageColumn } from "../metadata/user";
import { useGetUserMessageQuery, useSendUserExcelWhatsappMutation, useSendUserWhatsappMutation } from "../store/api/userAPI";

const UploadExcel = () => {
	const [file, setFile] = useState(null);
	const [message, setMessage] = useState("");
	const { data, error, isLoading } = useGetUserMessageQuery();
	const [sendUserWhatsapp, { isLoading: isLoadingSend, isError }] = useSendUserExcelWhatsappMutation(); // Используем хук RTK Query
	const handleFileChange = (e) => {
		setFile(e.target.files[0]);
	};

	const handleUpload = async (e) => {
		e.preventDefault();

		if (!file) {
			setMessage("Выберите файл!");
			return;
		}

		const formData = new FormData();
		formData.append("file", file);

		try {
			// Вызываем мутацию
			const response = await sendUserWhatsapp(formData).unwrap();
			setMessage("✅ " + response.message);
		} catch (err) {
			setMessage("❌ Ошибка: " + err.message);
		}
	};

	return (
		<>
			<div style={{ maxWidth: 400, margin: " auto", textAlign: "center" }}>
				<h2 style={{ margin: "0" }}>Загрузите файл xlsx. Обязательно должны быть поля phone, message </h2>
				<form onSubmit={handleUpload}>
					<div className="flex justify-content-center">
						<div className="editor">
							<div className="file_upload">
								<input type="file"
									accept=".xlsx,.xls"
									onChange={handleFileChange} className='file_upload_inp' />
								<label htmlFor="" className="file_upload_label">{t("download")}</label>
								<p className='file_upload_link'>
									{file ? `📄 ${file.name}` : "Файл не выбран"}
								</p>
							</div>
						</div>
					</div>
					<button
						type="submit"
						disabled={isLoadingSend}
						style={{
							padding: "10px 20px",
							backgroundColor: isLoadingSend ? "#90caf9" : "#1976d2",
							color: "#fff",
							border: "none",
							borderRadius: "6px",
							cursor: isLoadingSend ? "not-allowed" : "pointer",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							gap: "10px",
							minWidth: "140px",
						}}
					>
						{isLoadingSend ? (
							<>
								<span className="loader" />
								Отправка...
							</>
						) : (
							"Загрузить"
						)}
					</button>
				</form>
				{message && <p style={{ marginTop: "20px" }}>{message}</p>}
			</div>
			<PresortDemo
				scrollHeight="calc(100vh - 200px)"
				isLoading={isLoading}
				data={data}
				column={userMessageColumn ?? Object.keys(data.data[0])}
				actions={[]} />
		</>

	);
};

export default UploadExcel;
